import React, { useState } from 'react'
import orderBy from 'lodash/orderBy'
import { connect } from 'react-redux'
import { deserializePage } from 'supporticon/api/pages'
import { usePages } from '../../utils/use-pages'
import { selectCustomSupporterPagePresent } from '../../../store/customSupporterPages'
import { selectAPIParams } from '../../../store/site'

import Content from '../../ui/Content'
import Error from '../../ui/Error'
import Filter from 'constructicon/filter'
import Grid from 'constructicon/grid'
import Loading from '../../ui/Loading'
import Pagination from 'constructicon/pagination'
import PaginationLink from 'constructicon/pagination-link'
import ProgressTiles from '../../ui/ProgressTiles'
import Section from '../../ui/Section'

const PageProgressTiles = ({
  action,
  alignment,
  apiParams,
  background,
  backgroundImage,
  barColor,
  buttonBackground,
  buttonForeground,
  campaignOverride,
  copy,
  copyAlignment,
  donationUrlParams,
  excludePageIds,
  foreground,
  fundedAction,
  group,
  hasCustomSupporterPages,
  includeFilter,
  limit,
  metric,
  order,
  pageIds,
  pageSize,
  size,
  sort,
  spacing,
  subtitle,
  title,
  titleForeground,
  titleSize
}) => {
  const [filter, setFilter] = useState('')

  const sortPages = pages => {
    switch (order) {
      case 'amount':
        return orderBy(pages, ['raised'], [sort])
      case 'target':
        return orderBy(pages, ['target'], [sort])
      case 'date':
        return orderBy(pages, ['campaignDate'], [sort])
      case 'id':
        return orderBy(pages, ['id'], [sort])
      default:
        return orderBy(pages, ['name'], [sort])
    }
  }

  const deserializeMethod = data => {
    const page = deserializePage(data)

    if (hasCustomSupporterPages) {
      return {
        ...page,
        url: `/${page.type === 'team' ? 'teams' : 'fundraising'}/${page.slug}`
      }
    }

    return page
  }

  const { data = [], status } = usePages({
    ...apiParams,
    allPages: (pageIds && pageIds.split(',').length > 0) || apiParams.event,
    ids: pageIds,
    campaign: campaignOverride || apiParams.campaignIds,
    group,
    limit: limit || 20
  }, { deserializeMethod })

  const removeExcludedPages = (pages, excludePageIds) => {
    if (!excludePageIds) return pages
    return pages.filter(page => excludePageIds.indexOf(page.id) === -1)
  }

  const pages = sortPages(removeExcludedPages(data, excludePageIds))
    .map(page => {
      const isFunded = page.raised >= page.target
      const isDisabled = isFunded && fundedAction === 'disable'

      return {
        ...page,
        raised: page.raised,
        target: page.target,
        status: 'fetched',
        actions: [{
          to: action === 'view'
            ? isDisabled ? '' : page.url
            : isDisabled ? '' : [page.donationUrl, donationUrlParams].filter(Boolean).join(''),
          label: action === 'view'
            ? isDisabled ? 'Project Funded' : 'View Page'
            : isDisabled ? 'Project Funded' : 'Donate Now'
        }]
      }
    })
    .filter(page => {
      return filter
        ? page.name.toLowerCase().indexOf(filter.toLowerCase()) !== -1
        : true
    })

  return (
    <Section
      alignment={alignment}
      backgroundImage={backgroundImage}
      background={background}
      foreground={foreground}
      size={size}
      spacing={spacing}>

      <Content
        copy={copy}
        copyAlignment={copyAlignment}
        subtitle={subtitle}
        title={title}
        titleForeground={titleForeground}>

        {status === 'loading' && <Loading />}
        {status === 'error' && <Error>There was an error loading pages.</Error>}
        {status === 'success' && (
          <div>
            {includeFilter === 'yes' && <Filter onChange={setFilter} />}
            <Pagination max={pageSize || limit || 20} toPaginate={pages}>
              {({ canNext, canPrev, currentPage, isPaginated, next, prev }) => (
                <div>
                  <ProgressTiles
                    action={action}
                    barColor={barColor}
                    buttonBackground={buttonBackground}
                    buttonForeground={buttonForeground}
                    data={currentPage}
                    metric={metric}
                    titleForeground={titleForeground}
                    titleSize={titleSize}
                  />
                  {isPaginated && (
                    <Grid spacing={1} justify='center'>
                      <PaginationLink onClick={prev} direction='prev' disabled={!canPrev} />
                      <PaginationLink onClick={next} direction='next' disabled={!canNext} />
                    </Grid>
                  )}
                </div>
              )}
            </Pagination>
          </div>
        )}
      </Content>
    </Section>
  )
}

const mapState = (state) => ({
  ...selectAPIParams(state),
  ...selectCustomSupporterPagePresent(state)
})

export default connect(mapState)(PageProgressTiles)
